import axios from "axios";

const API = axios.create({
  baseURL: "https://api.ilogically.com/api/notification"
});

// CREATE
export const createCampaign = (payload) =>{
  
  API.post(`/campaigns?appToken=${payload?.appToken}&currentToken=${payload?.currentToken}`, payload);
}
 

// EDIT
export const updateCampaign = (id, payload) =>
  API.put(`/campaigns/${id}?appToken=${payload?.appToken}&currentToken=${payload?.currentToken}`, payload);

// CANCEL
export const cancelCampaign = (id, payload) =>
  API.post(`/campaigns/${id}/cancel?appToken=${payload?.appToken}&currentToken=${payload?.currentToken}`);

// DELETE
export const deleteCampaign = (id, payload) =>
  API.delete(`/campaigns/${id}?appToken=${payload?.appToken}&currentToken=${payload?.currentToken}`);

// DUPLICATE
export const duplicateCampaign = (id, payload) =>
  API.post(`/campaigns/${id}/duplicate?appToken=${payload?.appToken}&currentToken=${payload?.currentToken}&tenantId=${payload?.tenantId}`);

// GET ONE
export const getCampaignById = (id, payload) =>
  API.get(`/campaigns/${id}?appToken=${payload?.appToken}&currentToken=${payload?.currentToken}`);

// LIST / FILTER
export const getCampaigns = (params) =>
  API.get(`/campaigns`, { params });

// SUMMARY
export const getCampaignSummary = (id, payload) =>
  API.get(`/campaigns/${id}/summary?appToken=${payload?.appToken}&currentToken=${payload?.currentToken}`);
